export default function PageHero({
  overline,
  title,
  subtitle,
  image,
  testId,
}) {
  return (
    <section
      className="relative w-full h-[60vh] min-h-[420px] max-h-[640px] overflow-hidden bg-black"
      data-testid={testId || "page-hero"}
    >
      <img
        src={image}
        alt=""
        className="absolute inset-0 w-full h-full object-cover opacity-70"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/40 to-black/10" />
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex flex-col justify-end pb-16 sm:pb-20">
        {overline && (
          <p className="overline text-white/80 mb-4" data-testid="hero-overline">
            {overline}
          </p>
        )}
        <h1
          className="font-serif-display text-white text-5xl sm:text-6xl lg:text-7xl leading-[0.95] max-w-3xl"
          data-testid="hero-title"
        >
          {title}
        </h1>
        {subtitle && (
          <p
            className="mt-6 text-white/85 text-base sm:text-lg max-w-xl leading-relaxed"
            data-testid="hero-subtitle"
          >
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
}
